import { TimeframeSelect, TimeframeSelectStateProps, TimeframeSelectDispatchProps, TimeframeSelectOwnProps } from 'components/features/pfm/PageParamsHeader/TimeframeSelect'
import { State } from 'interfaces/state'
import { timeframeSelector } from 'selectors/globalSelectors'
import { TIMEFRAME_TYPES, FUTURE_TIMEFRAME_TYPES } from 'constants/datetime'
import { MapDispatchToPropsFunction, connect } from 'react-redux'
import { setTimeframeActionCreator } from 'actions/globalActions'
import { trackUIEventAction } from 'actions/analyticsActions'

const mapStateToProps = (state: State, ownProps: TimeframeSelectOwnProps): TimeframeSelectStateProps => {
  const selectedTimeframe = timeframeSelector(state, ownProps)

  return {
    options: ownProps.type === 'future' ? FUTURE_TIMEFRAME_TYPES : TIMEFRAME_TYPES,
    selected: selectedTimeframe,
  }
}

const mapDispatchToProps: MapDispatchToPropsFunction<TimeframeSelectDispatchProps, TimeframeSelectOwnProps> = (dispatch, ownProps) => ({
  changeTimeframe: (timeframe) => dispatch(setTimeframeActionCreator(ownProps.type, timeframe)),
  trackUIEvent: (event) => dispatch(trackUIEventAction(event)),
})

export const TimeframeSelectContainer = connect<
  TimeframeSelectStateProps,
  TimeframeSelectDispatchProps,
  TimeframeSelectOwnProps
>(mapStateToProps, mapDispatchToProps)(TimeframeSelect)
